/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  HomeSummary,
  OrganizationOverview,
  ReviewSummary,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    HomeSummaryFromJSON,
    HomeSummaryToJSON,
    OrganizationOverviewFromJSON,
    OrganizationOverviewToJSON,
    ReviewSummaryFromJSON,
    ReviewSummaryToJSON,
} from '../models/index';

export interface GetHomeSummaryRequest {
    xOrganizationID?: string | null;
}

export interface GetOrganizationOverviewRequest {
    xOrganizationID?: string | null;
}

export interface GetReviewSummaryRequest {
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class OverviewApi extends runtime.BaseAPI {

    /**
     * Home summary of the organization in the header for a member of its staff.  401 without a user, 403 for a caller who is not staff. Read-only.  - **today**: workshops starting today (Europe/Zagreb); admins and the owner see every   workshop of the organization, other staff the workshops they mentor - **upcoming**: the same scope over the next 7 days after today, at most 10 - **review**: the same as `GET /overview/review` - **classes**: distinct classes of the caller\'s workshops from 90 days ago to 30 days ahead - **admin**: license state, seats and pending event invitations; null unless the caller   administers or owns the organization
     * Get Home Summary
     */
    async getHomeSummaryRaw(requestParameters: GetHomeSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HomeSummary>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overview/home`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeSummaryFromJSON(jsonValue));
    }

    /**
     * Home summary of the organization in the header for a member of its staff.  401 without a user, 403 for a caller who is not staff. Read-only.  - **today**: workshops starting today (Europe/Zagreb); admins and the owner see every   workshop of the organization, other staff the workshops they mentor - **upcoming**: the same scope over the next 7 days after today, at most 10 - **review**: the same as `GET /overview/review` - **classes**: distinct classes of the caller\'s workshops from 90 days ago to 30 days ahead - **admin**: license state, seats and pending event invitations; null unless the caller   administers or owns the organization
     * Get Home Summary
     */
    async getHomeSummary(requestParameters: GetHomeSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HomeSummary> {
        const response = await this.getHomeSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Usage overview of the organization in the header for its administrators.  401 without a user, 403 unless the caller administers or owns the organization. Read-only.  - **students_active** / **staff_active**: active users with an active role, each counted   once; staff hold a staff role or own the organization - **classes**: classes that are not deleted - **workshops_this_week** / **workshops_next_week**: Monday 00:00 to Monday 00:00,   Europe/Zagreb - **attendance_30d**: workshops that started in the last 30 days and their attendance - **license**: license state and seats in use - **recent_workshops**: the last 5 workshops that started, with attendance counts
     * Get Organization Overview
     */
    async getOrganizationOverviewRaw(requestParameters: GetOrganizationOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationOverview>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overview/organization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationOverviewFromJSON(jsonValue));
    }

    /**
     * Usage overview of the organization in the header for its administrators.  401 without a user, 403 unless the caller administers or owns the organization. Read-only.  - **students_active** / **staff_active**: active users with an active role, each counted   once; staff hold a staff role or own the organization - **classes**: classes that are not deleted - **workshops_this_week** / **workshops_next_week**: Monday 00:00 to Monday 00:00,   Europe/Zagreb - **attendance_30d**: workshops that started in the last 30 days and their attendance - **license**: license state and seats in use - **recent_workshops**: the last 5 workshops that started, with attendance counts
     * Get Organization Overview
     */
    async getOrganizationOverview(requestParameters: GetOrganizationOverviewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationOverview> {
        const response = await this.getOrganizationOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Results waiting for review in the caller\'s workshops of the organization in the header.  401 without a user, 403 for a caller who is not staff. Read-only. The same as the `review` block of `GET /overview/home`.  - Workshops: active, started in the last 30 days; administrators and the owner count every   workshop of the organization, other staff only the workshops they mentor - Queues: the rule of `GET /judge/review/?workshop_id=` - **total**: distinct results (submission and test case) across those queues; a result in   the queues of several workshops counts once - **workshops**: the top 5 workshops by queue size, each with its own count
     * Get Review Summary
     */
    async getReviewSummaryRaw(requestParameters: GetReviewSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReviewSummary>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overview/review`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReviewSummaryFromJSON(jsonValue));
    }

    /**
     * Results waiting for review in the caller\'s workshops of the organization in the header.  401 without a user, 403 for a caller who is not staff. Read-only. The same as the `review` block of `GET /overview/home`.  - Workshops: active, started in the last 30 days; administrators and the owner count every   workshop of the organization, other staff only the workshops they mentor - Queues: the rule of `GET /judge/review/?workshop_id=` - **total**: distinct results (submission and test case) across those queues; a result in   the queues of several workshops counts once - **workshops**: the top 5 workshops by queue size, each with its own count
     * Get Review Summary
     */
    async getReviewSummary(requestParameters: GetReviewSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReviewSummary> {
        const response = await this.getReviewSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
